import Keycloak from 'keycloak-js'

import {
  Dispatch,
  ReactElement,
  ReactNode,
  createContext,
  useContext,
  useReducer,
} from 'react'
import { UserReducerAction } from './reducer/UserReducerAction'
import { UserState } from './state/UserState'
import { initialUserState } from './state/InitialState'
import KeycloakContext from '../../../auth/KeycloakContext'
import { userReducer } from './reducer/UserReducer'

export interface UserContextType {
  state: UserState
  dispatch: Dispatch<UserReducerAction>
  keycloak: Keycloak
}

export const UserContext = createContext<UserContextType>({
  state: initialUserState,
  dispatch: () => {},
  keycloak: new Keycloak(undefined),
})

interface Props {
  children: ReactNode
}

export const UserContextProvider = ({ children }: Props): ReactElement => {
  const { keycloak } = useContext(KeycloakContext)
  const [state, dispatch] = useReducer(userReducer, initialUserState)

  return (
    <UserContext.Provider value={{ state, dispatch, keycloak }}>
      {children}
    </UserContext.Provider>
  )
}
